import { PureLightTheme } from "../../../styles/theme"
import { COLORS } from "../../../styles/variables"

/** Border color matches toast.success (`COLORS.STOPLIGHT_GO_GREEN`). */
export const CompletionCardSx = {
    border: `1px solid ${COLORS.STOPLIGHT_GO_GREEN}`,
    [PureLightTheme.breakpoints.down('sm')]: {
        border: `1px solid ${COLORS.STOPLIGHT_GO_GREEN}`,
        borderRadius: '12px',
        padding: '12px',
        background: COLORS.WHITE,
    },
}

export const CardImg = {
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginRight: 3,

    [PureLightTheme.breakpoints.down('sm')]: {
        display: 'none',
    }
}

export const CardImgMobile = {
    maxWidth: '600px',
    width: 'calc(100% + 24px)',
    maxHeight: '600px',
    objectFit: 'cover',
    mb: 1.5,
    mx: -1.5,
    '@media (min-width:600px)': {
        display: 'none',
    },
}

export const TypTitle = {
    marginTop: 1.5,
    marginBottom: 1,
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflowWrap: 'anywhere',
    [PureLightTheme.breakpoints.down('sm')]: {
        fontSize: '18px',
        marginTop: 0,
        marginBottom: 0,
    }
}
